import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { paths } from '../path';
import { TokenHelper } from '../../utils/tokenHelper';

const isUserAuth = () =>
    TokenHelper.isTokenValid() && !!localStorage.getItem('loggedInUserSummary');

export const RequireAuth = () => {
    const location = useLocation();

    if (isUserAuth()) {
        return <Outlet />;
    }

    const isInviteLink =
        location.pathname === paths.public.register &&
        new URLSearchParams(location.search).has('user');

    if (isInviteLink) {
        return <Outlet />;
    }

    const returnUrl = location.pathname + location.search;

    return <Navigate to={paths.public.login} state={{ returnUrl }} replace />;
};
